import React from 'react';
import { NavItem } from './NavItem';
export function Sidebar({
  activePage,
  onNavigate
}: {
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  return <div className="w-[300px] bg-[#111111] h-screen flex flex-col sticky top-0" data-id="element-105">
      <div className="h-[80px]" data-id="element-106" /> {/* Spacer for logo */}
      <nav className="flex-1 py-12 px-8 pt-[64px] pb-[64px]" data-id="element-107">
        <ul className="space-y-6 flex flex-col items-start" data-id="element-108">
          <li className="w-full" data-id="element-109">
            <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => onNavigate('complexity')} data-id="element-110" />
          </li>
          <li className="w-full" data-id="element-111">
            <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => onNavigate('research')} data-id="element-112" />
          </li>
          <li className="w-full" data-id="element-113">
            <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => onNavigate('systems')} data-id="element-114" />
          </li>
        </ul>
      </nav>
      <div className="h-[72px]" data-id="element-115" /> {/* Spacer for copyright */}
    </div>;
}